module.exports = __webpack_public_path__ + "img/dash-circle.5c62a563.svg";